import React, { lazy, Suspense } from 'react';
import {
    Routes,
    Route,
    Navigate,
    useLocation
} from 'react-router-dom';
import { useAppSelector } from 'hooks/useStore';

// const Landing = lazy(() => import('pages/public/Landing'));
// const SignIn = lazy(() => import('pages/public/SignIn'));
// const SignUp = lazy(() => import('pages/public/SignUp'));
// const PasswordReset = lazy(() => import('pages/public/PasswordReset'));
// const Onboarding = lazy(() => import('pages/public/Onboarding'));
// const Courses = lazy(() => import('pages/public/Courses'));
// const CourseInfo = lazy(() => import('pages/public/CourseInfo'));
// const Tests = lazy(() => import('pages/public/Tests'));
// const FullSATLevelTest = lazy(() => import('pages/public/FullSATLevelTest'));

import Landing from 'pages/public/Landing';
import SignIn from 'pages/public/SignIn';
import SignUp from 'pages/public/SignUp';
import PasswordReset from 'pages/public/PasswordReset';
import Onboarding from 'pages/public/Onboarding';
import Register from 'pages/public/Register';
import Courses from 'pages/public/Courses';
import SAT from 'pages/public/Tests/SAT';
import PSAT from 'pages/public/Tests/PSAT';
import ACT from 'pages/public/Tests/ACT';
import DailyQuestion from 'pages/public/DailyQuestion';
// import CourseInfo from 'pages/public/CourseInfo';
import LevelTest from 'pages/public/LevelTest';
import TestFinder from 'pages/public/TestFinder';
import FullSATLevelTest from 'pages/public/FullSATLevelTest';
import NotFound from 'pages/error/NotFound';
import Unauthorized from 'pages/error/Unauthorized';
import ServerError from 'pages/error/ServerError';

import KatexTester from 'pages/test/KatexTester';

function PublicRoutes() {
    const { authenticated } = useAppSelector(state => state.user);
    const { status } = useAppSelector(state => state.error);

    const { pathname } = useLocation();

    const signInRedirectPaths = ['/test/:testId'];

    if (status === 401) return <Unauthorized />;
    else if (status !== null) return <ServerError />;

    return (
        <Suspense fallback={<></>}>
            <Routes>
                <Route path='/' element={<Landing />} />
                <Route path='/register' element={<Register />} />
                <Route path='/courses' element={<Courses />} />
                <Route path='/tests/digital-sat' element={<SAT />} />
                <Route path='/tests/digital-psat' element={<PSAT />} />
                <Route path='/tests/digital-act' element={<ACT />} />
                <Route path='/daily-question' element={<DailyQuestion />} />
                {/* <Route path='/course'>
                    <Route path=':courseUrl' element={<CourseInfo />} />
                </Route> */}
                <Route path='/level-test' element={<LevelTest />} />
                <Route path='/test-finder' element={<TestFinder />} />
                <Route path='/test-finder/test' element={<Navigate to='/test-finder' replace />} />
                <Route path='/sat-or-act' element={<TestFinder />} />
                <Route path='/account' element={<Navigate to='/sign-in' />} />
                <Route path='/classroom' element={<Navigate to='/sign-in' />} />
                <Route path='/cart' element={<Navigate to='/sign-in' />} />
                {authenticated ? <>
                    <Route path='*' element={<Onboarding />} />
                </> : <>
                    <Route path='/sign-in' element={<SignIn />} />
                    <Route path='/sign-up' element={<SignUp />} />
                    <Route path='/onboarding' element={<Navigate to='/sign-in' />} />
                    <Route path='/password-reset' element={<PasswordReset />} />
                    {signInRedirectPaths.map(path => (
                        <Route key={path} path={path} element={
                            <Navigate
                                to='/sign-in'
                                replace
                                state={{ referrer: pathname }}
                            />
                        }/>
                    ))}
                </>}
                
                {!+process.env.PRODUCTION && <Route path='katex' element={<KatexTester />} />}
                
                <Route path='*' element={<NotFound />} />
            </Routes>
        </Suspense>
    );
}

export default PublicRoutes;